'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var normalStylesMap = {
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none'
};

var activeStylesMap = {
    fontWeight: 'bold',
    fontStyle: 'italic',
    textDecoration: 'underline'
};

var normalWeights = ['inherit', 'initial', 'normal', 300, '300'];
var normalFontStyles = ['inherit', 'initial', 'normal'];
var normalTextDecorations = ['inherit', 'initial', 'normal', 'none'];

var PROPS_STYLES_MAP = exports.PROPS_STYLES_MAP = {
    bold: 'fontWeight',
    italic: 'fontStyle',
    underline: 'textDecoration'
};

var STYLES_PROPS_MAP = exports.STYLES_PROPS_MAP = {
    fontWeight: 'bold',
    fontStyle: 'italic',
    textDecoration: 'underline'
};

var toProps = exports.toProps = function toProps(_ref) {
    var _ref$fontWeight = _ref.fontWeight,
        fontWeight = _ref$fontWeight === undefined ? normalStylesMap.fontWeight : _ref$fontWeight,
        _ref$fontStyle = _ref.fontStyle,
        fontStyle = _ref$fontStyle === undefined ? normalStylesMap.fontStyle : _ref$fontStyle,
        _ref$textDecoration = _ref.textDecoration,
        textDecoration = _ref$textDecoration === undefined ? normalStylesMap.textDecoration : _ref$textDecoration;
    return {
        bold: !normalWeights.includes(fontWeight),
        italic: !normalFontStyles.includes(fontStyle),
        underline: !normalTextDecorations.includes(textDecoration)
    };
};

var toStyles = exports.toStyles = function toStyles(_ref2) {
    var _ref2$bold = _ref2.bold,
        bold = _ref2$bold === undefined ? false : _ref2$bold,
        _ref2$italic = _ref2.italic,
        italic = _ref2$italic === undefined ? false : _ref2$italic,
        _ref2$underline = _ref2.underline,
        underline = _ref2$underline === undefined ? false : _ref2$underline;
    return {
        fontWeight: bold ? activeStylesMap.fontWeight : normalStylesMap.fontWeight,
        fontStyle: italic ? activeStylesMap.fontStyle : normalStylesMap.fontStyle,
        textDecoration: underline ? activeStylesMap.textDecoration : normalStylesMap.textDecoration
    };
};

exports.default = {
    toProps: toProps,
    toStyles: toStyles,
    PROPS_STYLES_MAP: PROPS_STYLES_MAP,
    STYLES_PROPS_MAP: STYLES_PROPS_MAP
};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/mapFontStyles.js
// module id = 1565
// module chunks = 0